/* eslint-disable no-param-reassign,max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FetchUsersFilterPayload, IUsersListResponse, IEndUserProfile, UsersState,
} from './interface';

export const initialState:UsersState = {
  loading: false,
  users: [],
  total: 0,
  profile: {
    id: '',
    profileImgUrl: '',
    email: '',
    firstName: '',
    lastName: '',
    bio: '',
    country: '',
    reviews: [],
    attributes: {
      dob: '',
      height: '',
      weight: '',
      bmi: '',
      sessionsPurchased: [],
      badges: [],
    },
  },
};

export const usersSlice = createSlice({
  name: 'feature/users',
  initialState,
  reducers: {
    getUsers(state: UsersState, action: PayloadAction<FetchUsersFilterPayload>) {
      state.loading = true;
    },
    getUsersSucceeded(state: UsersState, _action: PayloadAction<IUsersListResponse>) {
      const { result, total } = _action.payload;
      state.loading = false;
      state.users = result;
      state.total = total;
    },
    getUsersFailed(state: UsersState) {
      state.loading = false;
    },
    fetchUserProfile(state: UsersState, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchUserProfileSucceeded(
      state: UsersState,
      action: PayloadAction<IEndUserProfile>,
    ) {
      state.loading = false;
      state.profile = action.payload;
      state.profile.reviews = action.payload?.reviews ?? [];
      state.profile.attributes.badges = action.payload.attributes?.badges ?? [];
      state.profile.attributes.sessionsPurchased = action.payload.attributes?.sessionsPurchased ?? [];
    },
    fetchUserProfileFailed(state: UsersState) {
      state.loading = false;
    },
  },
});

export const { actions: usersAction } = usersSlice;
